import { SkillsSubNavigation } from './skills-sub-navigation-model';

export function transformSkillsSubNavigation(
  subNav: SkillsSubNavigation,
): SkillsSubNavigation {
  return subNav;
}
